export default __webpack_public_path__ + "static/media/marvel-thor.c63e651c.jpg";